<template>
  <page-common type="normal" :showAppTopLink="isSharePage" :showAppBotLink="false" :detail="dataAll">
  <div :style="(!isSharePage)?{height:'100vh'}:{}" class="wrapper">
    <button class="content-button"></button>
    <!-- <video :src="data.resources?data.resources[1].url:''" :poster="data.image?data.image:''" webkit-playsinline="true" x5-video-player-type="h5" x5-video-orientation="portraint" webkit-appearance="none" playsinline="true" x5-playsinline="true" x-webkit-airplay="allow" controlslist="nodownload" >
    </video> -->
    <video
      :src="data.resources?data.resources[1].url:''"
      style="object-fit:contain"
      :poster="data.image?data.image:''"
      controlslist="nodownload"
      x-webkit-airplay="allow"
      webkit-playsinline="playsinline"
      x5-video-orientation="portraint"
      x5-video-player-type="h5-page"
      webkit-appearance="none"
      playsinline
    ></video>

    <div class="info-box">
      <div class="info-bottom">
        <p class="info-auth">@{{authors}}</p>
        <p ref="dsc" class="info-desc" :class="showMoreDesc?'showmore':''">{{desc}} <span ref="morebtn" @click="showMore" class="info-more">{{showMoreDesc?'收起':'更多'}}<span  class="arrow"><img src="../images/btn_open_video.png"></span></span></p>
      </div>
    </div>
  </div>
  </page-common>
</template>

<script>
import Vue from 'vue'
import { Lazyload, MessageBox, Toast } from 'mint-ui';
import api from 'src/constants/appapi'
import PageCommon from './page-common'
import { intfc_prefix_common, govUrl } from 'constants/project'
import icon from 'src/images/icon_user_default_avatar.png'
import wx from "../services/weChatShare"
Vue.use(Lazyload);

export default {
  data () {
    return {
       getedMoreHeight:false,
       timer: undefined,
       showMoreDesc: false,
       isSharePage: false, // 是否为分享页面
       data: {}, // 接口数据
       dataAll:{}, 
       authors:"",
       desc:"",
       fontSizeNum: 3, // 字体设置大小  1-5 小-大
       isPreviewPage:false
    }
  },
   watch: {
          dataAll: {
            handler (val) {      
              console.log(11111,val)     
                if (this.isSharePage) {
                    wx({
                        title: val.title.substr(0,128),
                    },this)
                }
                
                // this.pageUpdate()
            },
            deep: true
          },
        },
  created () {
      // 暴露方法给webview
        window.appapi = api
        window.$vm = this
        // 设置字体大小
        appapi.changeFontSize(this.$route.query.fontsize)
        this.isPreviewPage = appapi.isPreviewPage()
        this.isSharePage = appapi.isSharePage()
        this.initNormal(this.$route.params.id)
  },
  destroyed () {
      const wraper = document.querySelector(".wrapper");
      const vbutton = wraper.querySelector(".content-button");
      const video = wraper.querySelector("video");
      const _this = this;
      vbutton.removeEventListener("click");
      video.removeEventListener("playing");
      video.removeEventListener("pause");
      video.removeEventListener("ended");
      
  },
  mounted () {
    this.setVideoUI();
   
  },
  updated() {
    if(!this.getedMoreHeight){
      this.$nextTick(() => {
       this.getCanShowMore()
       this.getedMoreHeight =true;
      })
    }
    
  },
  methods: {
    getCanShowMore (){
      console.log(this.$refs.dsc.clientHeight,this.$refs.dsc.scrollHeight)
      if(this.$refs.dsc.clientHeight+2<this.$refs.dsc.scrollHeight){
        
      } else{
        this.$refs.morebtn.parentNode.removeChild(this.$refs.morebtn)
      }
    },
    showMore () {
      this.showMoreDesc = !this.showMoreDesc
    },
    appPostMessage (name, value='') {
            // 调用app原生方法
            if (name) window.appapi.appPostMessage(name, value)
    },
    setVideoUI () {
      const wraper = document.querySelector(".wrapper");
      const vbutton = wraper.querySelector(".content-button");
      const video = wraper.querySelector("video");
      const _this = this;
      vbutton.addEventListener("click",function(){
        console.log("!111111111111")
        video.play();
        vbutton.style.display = 'none';
        // video.setAttribute("controls","controls")
        this.timer = setTimeout(function(){
           video.removeAttribute("controls");
        },1000)
      });
      video.addEventListener("click",function(e){
        clearTimeout(this.timer);
        // video.setAttribute("controls","controls");
        video.pause();
      });
       video.addEventListener("playing",function(){
         _this.appPostMessage('getNetState')
      });
      video.addEventListener("pause",function(){
        video.removeAttribute("controls");
        vbutton.style.display = '';
      });
      video.addEventListener("ended",function(){
        video.removeAttribute("controls");
        vbutton.style.display = '';
      });
      
    },
    initNormal (id)  {
            let query = this.$route.query;
            let isTimeLimit = query.isTimeLimit;
            let articleUrl = `${intfc_prefix_common}/api/v2/articles/detail/`;
            if (!!isTimeLimit) {
                articleUrl = `${intfc_prefix_common}/api/v2/articles/detailPreview/`;
            }
            // 普通接口
            this.$axios.get(`${articleUrl}${id}`)
                .then(res=> {
                    const result1 = res.item
                    const result = res.item.medias[0] ? res.item.medias[0] :undefined
                    if (res.code === 0 && result) {
                        this.data = result;
                        this.dataAll = result1;
                        this.authors = res.item.authors;
                        this.desc = res.item.description;
                        this.appPostMessage('renderFinish')
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        },
  },
  components: {
    PageCommon,
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "~src/stylus/mixin";
  .content-button 
      margin: 0 0 -50px -50px;
  .wrapper
      position relative
      font-family: 'FZBIAOYSK','FZBIAOYSKIOS','FZBIAOYSKIOS BOLD','PingFang SC', '微软雅黑', sans-serif;
      height calc(100vh - 110px )
      video
          height 100%
          width 100%
          background #000
      .info-box
          width 100%
          height 4.56rem
          background: linear-gradient(180deg,rgba(0,0,0,0), rgba(0,0,0,0.73));
          position absolute
          bottom  0rem
          left 0
        .info-bottom 
            padding-left 0.4rem
            padding-right 0.4rem
            position absolute
            box-sizing border-box
            width 100%
            bottom  0rem
            padding-bottom 0.4rem
            left 0
            color: #ffffff
          .info-auth
            font-size:0.373rem
            line-height: .42rem;
            margin-bottom .266rem
          .info-desc
              font-size:0.32rem
              -webkit-line-clamp 2
              display:-webkit-box
              /* autoprefixer: off */
              -webkit-box-orient: vertical;
              /* autoprefixer: on */
              max-height: .90667rem
              line-height: .45333rem
              width 6.93rem
              overflow hidden
              transition max-height 2s
          .info-more
              position absolute
              left  7.5rem
              bottom 0.4rem
              display inline-block
              width 1.2rem    
              .arrow 
                display inline-block      
                width 0.28rem
                height 0.28rem
                margin-left 1px
                img
                  transform-origin center
                  width 100%
                  height 100%
        .showmore
          -webkit-line-clamp unset
          max-height 10.56rem
          .arrow
            img
              width 100%
              height 100%
              transform rotate(180deg)
</style>


// WEBPACK FOOTER //
// film.vue?0e0045a6